import React from 'react';
import HeaderLabel from "./HeaderLabel";
import {FieldBlock,InputBlock,ErrorBlock} from '../../../../hoc/FormInput';
import Wrp from '../../../../hoc/Wrp/Wrp';
import { isSet } from '../../../../Utils/CommonFunctions';


export const FormBlocks = (props) =>{
  let inputBlockClass = (props.inputBlockClass)?props.inputBlockClass:'';
  // if('Billing State'===props.item.label.blocks[0].text)
  // console.log('props.attr.validation',props.attr.validation);
  
    return (
      <Wrp>
        {(props.formType==='SUBFORM')?
          <Wrp> 
          <div className='input-group'>
          {props.children}
          {props.appendBlocks}
          </div>
            <ErrorBlock {...props.attr.validation}/>    
          </Wrp>
         :( props.withoutBlock===true)?
            <Wrp>
                {props.children}
                {isSet(props.errorBlock,false)===true &&
                  <ErrorBlock {...props.attr.validation}/>
                }
          </Wrp> 
        :( props.inputBlockOnly===true)?
          <Wrp> 
            <div className="form-group row">
            {(props.isLabel===undefined || props.isLabel===true)?
                <HeaderLabel
                  item={props.item}
                  {...props.item}
                  isPopupWindow={props.isPopupWindow}
                  sectionType={props.sectionType}
                  label={props.item.label}
                />
            :''}
            {(props.onlyInputComponent===true)?
              <div className="col-lg-12 col-md-12 col-sm-12">
                {props.children}
                <ErrorBlock {...props.attr.validation}/>
              </div>
            :
            <div className="col-lg-9 col-md-9 col-sm-8">
              {props.children}
              <ErrorBlock {...props.attr.validation}/>
            </div>}
            </div>  
          </Wrp>
        :
        <FieldBlock styles={props.attr.formGroupCss} isPopupWindow={props.isPopupWindow} section={props.section}  colType={props.column_type} item={props.item}>
        {(props.isLabel===undefined || props.isLabel===true)?
          <HeaderLabel
          item={props.item}
          {...props.item}
          isPopupWindow={props.isPopupWindow}
          sectionType={props.sectionType}
          label={props.item.label}
        />
        :''}
        <InputBlock {...props.attr} {...props.item} isPopupWindow={props.isPopupWindow} inputBlockClass={inputBlockClass}>
          <div >
            {props.children}
            {props.appendBlocks}
          </div>
        <ErrorBlock {...props.attr.validation}/>
        </InputBlock>
      </FieldBlock>
      }
      </Wrp>

    )
}
